import { Role } from '@/config/planCaps';

/**
 * API의 user.level을 Role 타입으로 변환
 *
 * @param level - API에서 받아온 user.level 값
 * @returns Role 타입 ('owner' | 'editor' | 'tester')
 */
export function mapUserLevelToRole(level?: string): Role {
  switch (level) {
    case 'Owner':
      return 'owner';
    case 'Author':
    case 'Developer':
      return 'editor';
    case 'Tester':
      return 'tester';
    default:
      // 기본값은 tester (가장 제한적인 권한)
      return 'tester';
  }
}

/**
 * Role을 한글로 변환
 */
export function roleToKorean(role: Role): string {
  switch (role) {
    case 'owner':
      return '소유자';
    case 'editor':
      return '편집자';
    case 'tester':
      return '테스터';
    default:
      return '테스터';
  }
}
